// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapsibleSection_container__UaKmj","body":"CollapsibleSection_body__Lvq2b","prefixSVG":"CollapsibleSection_prefixSVG__YjDGa"};